export default __webpack_public_path__ + "static/1_32-edf014ddb34197933cf505a89785d34f.png";